import React = require('react');
import Dialog from "material-ui/Dialog";
import diyLightTheme = require('diy/material-ui/diyLightTheme');

interface AssistanceDialogProps extends React.Props<AssistanceDialog> {
    className?: string;
}

export default class AssistanceDialog extends React.Component<AssistanceDialogProps, any> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    render(): JSX.Element {
        return (
            <Dialog open={true}
                    autoScrollBodyContent={true}
                    className={this.props.className}
                    contentClassName="migration-dialog assistance-dialog"
                    bodyClassName="dialog-body"
                    actionsContainerClassName="dialog-actions"
                    style={{zIndex: diy.editor.getNewTopZIndex()}}>

                {this.props.children}
            </Dialog>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/assistanceDialog/AssistanceDialog.tsx
 **/